import { ButtonWithDialog, Intent } from "@focus/focusUI";
import type { ApiKeyConfig } from "../../../types/apiKeys";
import { ApiKeyForm } from "./ApiKeysForm";

export const EditApiKeyButton = ({
  apiKey,
  disabled,
  onEdit,
}: {
  apiKey?: ApiKeyConfig;
  disabled?: boolean;
  onEdit: (apiKey: ApiKeyConfig) => void;
}) => (
  <ButtonWithDialog<ApiKeyConfig>
    closeAfterAccept
    defaultContent={apiKey}
    disabled={disabled || !apiKey}
    form={({ onUpdate, content }) => (
      <ApiKeyForm value={content} onChange={onUpdate} />
    )}
    headerTitle="Edit API key"
    hideButtons={false}
    icon="edit"
    intent={Intent.NONE}
    minimal
    onAccept={onEdit}
    tooltipText="Edit API key"
  />
);